
// import components
import Hero from '../components/Hero';
import About from './About';
import Skill from '../components/Skill';
import Contact from './Contact';
import useFetch from "../hooks/useFetch";
import Loading from '../components/Loading';
import Blog from '../components/Blog';

const Home = () => {
  let [data, loading] = useFetch("/home/index");


  return (
    <div>
      <Hero />
      {loading ? <Loading /> :
        (<div>
          <Blog label='Projects' data={data.projects}/>
          <Blog label='Articles' data={data.articles}/>
        </div>)}
      <About />
      <Skill />
      <Contact />
    </div>
  );
};


export default Home;